export const actionTypes = {
  GET_PRODUCTS_BY_PARTNER: "GET_PRODUCTS_BY_PARTNER",
  SET_PRODUCTS_BY_PARTNER: "SET_PRODUCTS_BY_PARTNER",

  UPDATE_PRODUCTS_BY_PARTNER: "UPDATE_PRODUCTS_BY_PARTNER"
};

export const actions = {
  getProductsByPartner: (payload) => ({
    type: actionTypes.GET_PRODUCTS_BY_PARTNER,
    payload: payload,
  }),

  setProductsByPartner: (payload) => ({
    type: actionTypes.SET_PRODUCTS_BY_PARTNER,
    payload: payload,
  }),

  updateProductPartner: (payload) => ({
    type: actionTypes.UPDATE_PRODUCTS_BY_PARTNER,
    payload: payload,
  }),
};
